import { memo, useCallback } from 'react';
import { MenuItem, Checkbox, Box, Typography } from '@mui/material';
import { LABELS } from '../../constants';
import { formatPostingDate } from '../../utils/glPostingMethods';
import ImmediateCloseTooltip from '../ImmediateCloseTooltip';

const displayName = 'SublocationMenuItem';

const SublocationMenuItem = memo(({ sublocation, isSelected, onToggle, classes, groupColor }) => {
  const id = sublocation?.id ?? '';
  const name = sublocation?.name ?? LABELS.NOT_AVAILABLE;
  const lastPosting = sublocation?.lastPosting;
  const endDate = formatPostingDate(lastPosting?.endDate);
  const dateLabel = endDate || LABELS.MISSING_END_DATE;

  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();
      onToggle(id);
    },
    [id, onToggle],
  );

  return (
    <MenuItem key={id} value={id} onClick={handleClick} className={classes.sublocationMenuItem}>
      <Checkbox checked={isSelected} />
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', minWidth: 0, pr: 1 }}>
        <Typography variant="body2" className={classes.sublocationName}>
          <ImmediateCloseTooltip title={name}>
            <span className={classes.sublocationNameText}>{name}</span>
          </ImmediateCloseTooltip>
        </Typography>
        <Typography
          variant="caption"
          className={classes.sublocationEndDate}
          sx={{ color: groupColor || 'text.secondary' }}
        >
          {dateLabel}
        </Typography>
      </Box>
    </MenuItem>
  );
});

SublocationMenuItem.displayName = displayName;

export default SublocationMenuItem;
